import {createAction} from '@reduxjs/toolkit';

import type {Team} from '@mattermost/types/teams';

type Payload = {
    teamId: Team['id'];
};

export const removeTeamThreads = createAction<Payload>('threads/actions/removeTeamThreads');
